<div class="p-3" [ngClass]="{'saved-view-mobile-wrapper': nvdbNavigationService.isMobileDevice}">
    <div style="display: flex; margin-bottom: 1rem; justify-content: space-between; align-items: center;">
        @if(lang.currentLanguage == Language.SV) {
        <trv-select [formControl]="nvdbNavigationService.savedViewsSortBy" placeholder="Sortera efter"
            [source]="_sortByOptions" valueKey="strategy" sortKey="strategy" [disableClear]="true"
            [displayMethod]="displaySortByName"></trv-select>
        } @else {
            <trv-select [formControl]="nvdbNavigationService.savedViewsSortBy" placeholder="Sortera efter"
            [source]="_sortByOptionsEn" valueKey="strategy" sortKey="strategy" [disableClear]="true"
            [displayMethod]="displaySortByName"></trv-select>
        }

        <button class="btn btn-primary" style="min-width: 100px;" type="button" [trvPopover]="popoverComponent"
            [position]="popoverPosition" (shown)="onShowComponent($event)">
            {{ lang.GetValue('SavedViews.SaveView') }}
        </button>
    </div>

    <app-saved-view-item [savedView]="SWEDEN_VIEW" [title]="SWEDEN_VIEW.name" [defaultView]="isDefaultView(SWEDEN_VIEW)"
        [swedenView]="true"></app-saved-view-item>

    <hr>

    @for (view of sortedSavedViews; track view) {
    <app-saved-view-item [savedView]="view" [title]="view.name"
        [defaultView]="isDefaultView(view)"></app-saved-view-item>
    }

    <span style="font-size: 11px">{{ lang.GetValue('SavedViews.SavedInfo') }}</span>
</div>